import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';
import { getCategoryValue, getPublicDataValue } from '../../util/data';
import { LISTING_PAGE_DETAILS_FIELDS, SCHEMA_TYPE_MULTI_ENUM } from '../../util/types';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl, categoryConfiguration } = props;

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
          ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
          : schemaType === 'long'
            ? filteredConfigs.concat({ key, value, label })
            : filteredConfigs;
    }
    return filteredConfigs;
  };



  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {LISTING_PAGE_DETAILS_FIELDS.map((field, i) => {
          const { key, label, } = field;
          // Extract the value from publicData for the current key
          const getValueFromPublicData = publicData?.[key] || null;
          if (!getValueFromPublicData) return null;
          // Return the list item
          return (
            <li key={label + i} className={css.detailsRow}>
              <span className={css.detailLabel}>{label}</span>
              <span className={ ["categoryName","subCategoryName"].includes(key) ? css.detailsValueCat : css.detailsValue}
                onClick={(e) => {
                  e.preventDefault();
                  if(!["categoryName","subCategoryName"].includes(key)){
                    return
                  }

                  const searchParams = {};
                  if (key == "categoryName") {
                    Object.assign(searchParams, { hierarchicalCategories: getValueFromPublicData })
                  }
                  if (key == "subCategoryName") {
                    Object.assign(searchParams, {
                      hierarchicalCategories: `${publicData["categoryName"]},${getValueFromPublicData}`
                    })
                  }

                  return history.push(createResourceLocatorString('SearchPage', routeConfiguration, {},
                    searchParams
                  ));
                }}

              >{getValueFromPublicData}</span>
            </li>
          );
        })}

      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
